module.exports = __webpack_public_path__ + "img/max-file-add.fc4d5d65.svg";